<template>
  <main class="container py-4" role="main">
    <h4>{{ $t("createNewCustomer") }}</h4>

    <b-form class="form-container" @submit.prevent="submitForm">
      <!-- <b-form-row> -->
<!--        <b-form-group class="col-lg-6">
          <template v-slot:label>{{ $t("customerId") }} <span class="text-danger">*</span></template>
          <b-form-input v-model="code" type="text" required maxlength="20"></b-form-input>
        </b-form-group>-->
        <b-form-group >
          <template v-slot:label>{{ $t("customerName") }} <span class="text-danger">*</span></template>
          <b-form-input v-model="name" type="text" required maxlength="100" autocomplete="name"></b-form-input>
        </b-form-group>
        <!-- <b-form-group class="col-lg-6">
          <template v-slot:label>{{ $t("customerType") }} <span class="text-danger">*</span></template>
          <b-form-select :options="typeOptions" v-model="type" required></b-form-select>
        </b-form-group>
      </b-form-row> -->
      <b-form-row>
        <b-form-group class="col-lg-6">
          <template v-slot:label>Email <span class="text-danger">*</span></template>
          <b-form-input v-model="email" type="email" required maxlength="100" autocomplete="email" />
        </b-form-group>
        <b-form-group class="col-lg-6">
          <template v-slot:label>{{ $t("phoneNumber") }} <span class="text-danger">*</span></template>
          <b-form-input type="tel" v-model="phoneNumber" required
                        :pattern="phonePattern" minlength="2" maxlength="50"
                        @invalid="$event.target.setCustomValidity($t('invalidPhoneFormat'))"
                        @input.native="$event.target.setCustomValidity('')" />
        </b-form-group>
      </b-form-row>

      <b-form-group>
              <template v-slot:label>{{ $t("province") }} <span  class="text-danger">*</span></template>
<!--              <b-form-select text-field="name" value-field="name" :options="provinceOptions" :required="isVNPT" v-model="province"></b-form-select>-->
              <v-select label="name" class="vs-normalizer"
                        :options="provinceOptions" :reduce="p => p.name"
                        :filterBy="provinceSelectSearch"
                        v-model="province">
                <template v-slot:search="{attributes, events}">
                  <input id="input-province" v-bind="attributes" v-on="events" v-model="province" required
                         class="form-control"  minlength="2" maxlength="100"/>
                </template>
              </v-select>
            </b-form-group>
            <b-form-group>
              <template v-slot:label>{{ $t("customerType") }} <span  class="text-danger">*</span></template>
              <b-form-radio-group class="mb-2" name="corporationType" :options="corporationTypeOptions" v-model="corporationType" @change="onCorporationTypeChange" />
              <!-- <select name="corporation"  v-model="corporation" class="custom-select">
                <option value="" disabled selected>{{ $t("pleaseChoose") }}</option>
                <option v-for="option in corporationOptions" :key="option" :value="option">{{ option }}</option>
              </select> -->

              <b-form-select v-if="corporationType === 'invnpt'" v-model="corporation" :options="corporationOptionsIn" class="mb-3" required>
              <template #first>
              <b-form-select-option :value="null" disabled>{{ $t("pleaseChoose") }}</b-form-select-option>
              </template>
              </b-form-select>
              <b-form-select v-else v-model="corporation" :options="corporationOptionsOut" class="mb-3" required>
              <template #first>
              <b-form-select-option :value="null" disabled>{{ $t("pleaseChoose") }}</b-form-select-option>
              </template>
              </b-form-select>


            </b-form-group>
      <b-form-group>
        <template v-slot:label>{{ $t("address") }} <span class="text-danger">*</span></template>
        <b-form-textarea v-model="address" required maxlength="200" />
      </b-form-group>
      <b-form-group>
        <template v-slot:label>{{ $t("taxCode") }} <span v-if="isTaxCodeRequired" class="text-danger">*</span></template>
        <b-form-input type="text" v-model="taxCode" :required="isTaxCodeRequired"
                      minlength="9" maxlength="20" pattern="^[0-9]+$"
                      @invalid="$event.target.setCustomValidity($t('invalidTaxCode'))"
                      @input.native="$event.target.setCustomValidity('')"/>
      </b-form-group>
      <b-form-row>
        <b-form-group class="col-lg-6">
          <template v-slot:label>{{ $t("documentType") }}</template>
          <b-form-select :options="documentTypeOptions" v-model="documentTypeId"></b-form-select>
        </b-form-group>
        <b-form-group class="col-lg-6">
          <template v-slot:label>{{ $t("documentNumber") }}</template>
          <b-form-input v-model="idCard" type="text"
                        minlength="9" maxlength="20" pattern="^[a-zA-Z0-9\-.]+$"
                        @invalid="$event.target.setCustomValidity($t('documentNumberInvalid'))"
                        @input.native="$event.target.setCustomValidity('')"/>
        </b-form-group>
      </b-form-row>
      <b-form-group>
        <template v-slot:label>{{ $t("issuePlace") }}</template>
        <b-form-input v-model="documentIssuePlace" type="text" maxlength="250"></b-form-input>
      </b-form-group>
      <b-form-row>
        <b-form-group class="col-lg-6">
          <template v-slot:label>{{ $t("issueDate") }}</template>
          <b-form-datepicker v-model="documentIssueDate"
                             :max="new Date()"
                             no-flip hide-header
                             label-no-date-selected="DD/MM/YYYY"
                             locale="vi"
                             :date-format-options="datePickerFormatOptions"
                             start-weekday="1"></b-form-datepicker>
        </b-form-group>
        <b-form-group class="col-lg-6">
          <template v-slot:label>{{ $t("expDate") }}</template>
          <b-form-datepicker v-model="documentExpiryDate"
                             :min="new Date()"
                             no-flip hide-header
                             label-no-date-selected="DD/MM/YYYY"
                             locale="vi"
                             :date-format-options="datePickerFormatOptions"
                             start-weekday="1"></b-form-datepicker>
        </b-form-group>
      </b-form-row>
      <b-form-group>
        <template v-slot:label>{{ $t("storageCapacity") }} <span class="text-danger">*</span></template>
        <b-input-group>
          <b-form-input type="number" min="500" max="1000000" required v-model="recordingStorage"/>
          <b-input-group-append>
            <b-input-group-text>MB</b-input-group-text>
          </b-input-group-append>
        </b-input-group>
        <div class="text-info mt-1">1 GB = 1000 MB</div>
      </b-form-group>
      <b-form-group :label="$t('note')">
        <b-form-textarea v-model="description" maxlength="255" />
      </b-form-group>

      <div v-if="formErrorMsg" class="text-danger">{{ formErrorMsg }}</div>

      <div class="text-center">
        <b-button type="submit" variant="primary" :disabled="isSubmitting" class="mt-4">{{ $t("createCustomer") }}</b-button>
      </div>
    </b-form>
  </main>
</template>

<style lang="scss" scoped>
  .form-container {
    max-width: 700px;
  }
</style>

<script lang="ts">
  import {Component, Vue} from 'vue-property-decorator';
  import _ from "lodash";
  import BaseComponent from "@/components/BaseComponent";
  import * as areaService from "@/service/areaService";
  import * as customerService from "@/service/customerService";
  import * as validationUtils from "@/service/validationUtils";

  import provinces from "@/provinces.json";
  import * as util from "@/service/util";
  @Component
  export default class CreateNewCustomer extends BaseComponent {

    datePickerFormatOptions = { year: 'numeric', month: '2-digit', day: '2-digit' };

    code = "1234";

    // type: string = null;
    // typeOptions = [
    //   { value: "Personal", text: this.$t("customerTypePersonal").toString() },
    //   { value: "Business", text: this.$t("customerTypeBusiness").toString() },
    // ];

    isVNPT = true;
    name = "";
    email = "";
    phoneNumber = "";
    address = "";

    taxCode = "";

    documentTypeId: number = null;
    documentTypeOptions = [];

    documentIssuePlace = "";
    documentIssueDate = null;
    documentExpiryDate = null;

    idCard = "";
    description = "";
    recordingStorage = 1000;

    formErrorMsg = "";
    isSubmitting = false;


    provinceOptions = provinces;
    province = "";
    corporationTypeOptions = [
      { value: "invnpt", text: this.$t("invnpt").toString() },
      { value: "outside", text:this.$t("outside").toString() },
    ];
    corporationType = "invnpt";
    // get corporationOptions() {
    //   if (this.corporationType === "in") {
    //     return [ this.$t("vinaphone").toString(), this.$t("media").toString(), this.$t("NET").toString(),this.$t("VT_TTP").toString() , this.$t("tdAgency").toString(),this.$t("IT").toString(), this.$t("other").toString() ];
    //   } else if (this.corporationType === "out") {
    //     return [ this.$t("customerTypePersonal").toString(),this.$t("customerTypeBusiness").toString(),this.$t("stateAgencies").toString() ,this.$t("other").toString()];
    //   }
    // }
    corporation = "";
    corporationOptionsIn = [
      { value: "vinaphone", text:  this.$t("vinaphone").toString() },
      { value: "media", text:  this.$t("media").toString() },
      { value: "net", text: this.$t("net").toString() },
      { value: "vt_ttp", text:  this.$t("vt_ttp").toString() },
      { value: "tdagency", text:  this.$t("tdagency").toString() },
      { value:"it", text:  this.$t("it").toString() },
      { value: "other", text:  this.$t("other").toString() },
    ];
    corporationOptionsOut = [
      { value: "personal", text: this.$t("personal").toString() },
      { value: "business", text: this.$t("business").toString() },
      { value: "organ", text:  this.$t("organ").toString() },
      { value: "other", text:  this.$t("other").toString() },
    ];
    mounted() {
      this.fetchDocumentTypes();
    }

    async fetchDocumentTypes() {
      try {
        const docTypes = await customerService.getDocumentTypes();
        this.documentTypeOptions = docTypes.map(it => ({ value: it.id, text: it.title }));

      } catch (e) {
        this.toastError(e);
      }
    }


    get isTaxCodeRequired() {
      return this.corporation === "business";
    }
    provinceSelectSearch(option, label, searchText) {
      searchText = util.sanitizeSearchText(searchText.toLowerCase());
      return util.sanitizeSearchText(label).toLowerCase().includes(searchText);
    }
    onCorporationTypeChange() {
      this.corporation = "";
    }


    async submitForm() {
      this.formErrorMsg = "";
      if (!validationUtils.isEmail(this.email)) {
        this.formErrorMsg = this.$t("invalidEmail").toString();
        return;
      }

      // if (!this.documentIssueDate) {
      //   this.formErrorMsg = this.$t("pleaseEnterDocumentIssueDate").toString();
      //   return;
      // }

      // if (!this.documentExpiryDate) {
      //   this.formErrorMsg = this.$t("pleaseEnterDocumentExpDate").toString();
      //   return;
      // }

      let data:any = {

        customerCode: this.code,
        areaId: this.getUserManagerSaleAreaId(),
        name: this.name,
        email: this.email,
        phoneNumber: this.phoneNumber,
        province: this.province,
        address: this.address,
        taxCode: this.taxCode || undefined,
        documentTypeId: this.documentTypeId,
        idCard: this.idCard,
        licensePlace: this.documentIssuePlace,
        licenseDate: this.documentIssueDate,
        licenseExpirationDate: this.documentExpiryDate,
        recordingStorage: +this.recordingStorage,
        description: this.description,
        customerType: this.corporationType,
      };
      if(this.corporationType === 'invnpt'){
        data.corporations= this.corporation
      }else{
        data.idType= this.corporation
      }

      try {
        this.isSubmitting = true;
        await customerService.newCustomer(data);

        await this.$router.push("/customers");
        this.toastSuccessDelay(this.$t("createNewCustomerSuccessful").toString());

      } catch (e) {
        this.toastError(e);
      } finally {
        this.isSubmitting = false;
      }
    }

  }
</script>
